import React, { useState, useEffect } from "react";
import DimensionsPlansBanner from "./DimensionsPlansBanner";
import PdfUploader from "./InputPdf";
import { useFormData } from "../../hooks/useFormData";
import { useParams } from "react-router-dom";

const DimensionsPlans = ({ onDataChange }) => {
  const { projectId } = useParams();
  const { formData, updateFormData } = useFormData(projectId);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [complementaryInfo, setComplementaryInfo] = useState(formData.complementary_info || '');

  // Notifier le parent des changements de données spécifiques à cette étape
  useEffect(() => {
    if (onDataChange) {
      onDataChange({
        complementary_info: complementaryInfo,
        uploadedFiles: uploadedFiles,
        documents: uploadedFiles.map(file => file.name) // Convertir les fichiers en noms pour l'API
      });
    }
  }, [complementaryInfo, uploadedFiles, onDataChange]);

  const handleFileChange = (files) => {
    setUploadedFiles(files);
    // Mettre à jour les données du formulaire avec les fichiers
    updateFormData('uploadedFiles', files);
  };

  const handleComplementaryInfoChange = (value) => {
    setComplementaryInfo(value);
    updateFormData('complementary_info', value);
  };

  return(
    <>
      <div className="bg-light">
        {/*section banner*/}
        {/* <DimensionsPlansBanner /> */}
        <div className="container">
          <div className="form-container">
            <div className="dark-form-head">
              <p className="text-center">
                Sur les plans se doit de figurer impérativement les éléments suivants
                :
              </p>
            </div>
            <div className="be-form p-3 p-md-5">
              <div className="">
                <div className="row">
                  <div className="col-12 col-sm-6 col-lg-3">
                    <div className="border-be">
                      <p className="text-center">Constructions existantes</p>
                    </div>
                  </div>
                  <div className="col-12 col-sm-6 col-lg-3">
                    <div className="border-be">
                      <p className="text-center">Mesures et cotations</p>
                    </div>
                  </div>
                  <div className="col-12 col-sm-6 col-lg-3">
                    <div className="border-be">
                      <p className="text-center">Unités</p>
                    </div>
                  </div>
                  <div className="col-12 col-sm-6 col-lg-3">
                    <div className="border-be">
                      <p className="text-center">Pentes de toiture</p>
                    </div>
                  </div>
                </div>
                <div className="to-consider mt-4">
                  <p className="text-center">
                    Tout élément manquant ou de qualité insuffisante peut mener à un
                    refus des plans et une invalidation de la demande
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="form-container">
            <div className="be-form p-3 p-md-5">
              <form>
                <p className="upload-plan-text">
                  Je dépose mes plans au format PDF pour le calcul des éléments et la
                  réalisation des quantitatifs <br />
                  (Vues en plan– Coupes– Façades)
                </p>
                <div className="d-flex justify-content-center">
                  <div className="custom-file-upload mt-4">
                    <PdfUploader onFileChange={handleFileChange} />
                    <label htmlFor="fileUpload">
                      Je sélectionne depuis mon ordinateur
                      <img
                        src="/assets/images/bureau-d-etude/upload_file_icon.png"
                        alt=""
                        width="15px"
                        className="ms-4"
                      />
                    </label>
                    <p id="file-name" />
                    <ul id="file-list" />
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="form-container">
            <div className="form-head">
              <p className="text-center" style={{ fontSize: 18 }}>
                Informations complémentaires
              </p>
            </div>
            <div className="be-form p-3 p-md-5">
              <form>
                <p className="be-description">
                  Mentionnez ici toute information permettant une meilleure
                  compréhension de votre projet. <br />
                  Profitez ainsi un chiffrage plus juste et plus rapide :
                </p>
                <textarea
                  id="be-textarea"
                  placeholder="Ecrivez votre texte ici..."
                  value={complementaryInfo}
                  onChange={(e) => handleComplementaryInfoChange(e.target.value)}
                />
              </form>
            </div>
          </div>
          {/* Navigation ici */}
        </div>
        {/* content close */}
        <a href="#" id="back-to-top" className="show" />
      </div>
    </>
  )
}

export default DimensionsPlans